
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { makeStyles, Typography } from "@material-ui/core";

import { GenericBox } from '../atoms/GenericBox';

const useStyles = makeStyles((theme) => ({
    switchBase: {
      color: '#bdbdbd',
      '&$checked': {
        transform: 'translateX(16px)',
        color: '#4CAF50',
        '& + $track': {
          backgroundColor: '#3E8040',
          opacity: 1,
          border: 'none',
        },
      },
    },
    TypographyRoot:{
        marginLeft: 20,
        marginRight: 10,
        color: '#757575'
    },
    checked: {},
    track: {},
  }));

export const SwitchGeneric = ({ value, onChange, color = "primary", name, label, disabled }) => {
    const classes = useStyles();

    return (
        <GenericBox display='flex' justifyContent='left' alignItems='center'>
            <Typography className={classes.TypographyRoot}>{label}</Typography>
            <FormControlLabel
                control={
                    <Switch
                        checked={value}
                        onChange={onChange}
                        disabled={disabled}
                        name={name}
                        color={color}
                        classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                }
            />
        </GenericBox>
    );
}
